import { Typography } from "@mui/material"
import type { ReactElement } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import CategorySelect from "@/screens/ManageProducts/components/ProductClasses/components/form/CategorySelect"
import ClassificationInput from "@/screens/ManageProducts/components/ProductClasses/components/form/ClassificationInput"
import ProductManagerSelect from "@/screens/ManageProducts/components/ProductClasses/components/form/ProductManagerSelect"
import type { ProductClassificationFormValues } from "@/screens/ManageProducts/components/ProductClasses/forms/classSchema"

interface ProductClassFormProps {
  onSubmit: () => void
}

const AddProductClassForm = ({ onSubmit }: ProductClassFormProps): ReactElement => {
  const { watch } = useFormContext<ProductClassificationFormValues>()

  const categoryIds = watch("category.id") ? [watch("category.id")] : []

  return (
    <form onSubmit={onSubmit} className='space-y-8'>
      <Typography className='text-ml text-gray-900'>
        Select a Category to classify, add class name and product manager
      </Typography>
      <CategorySelect />
      <ClassificationInput categoryIds={categoryIds} />
      <ProductManagerSelect />
    </form>
  )
}

export default AddProductClassForm
